import {flatClusters, flatPositions, idToOuId} from "../../helpers/Helpers";

const initialState = {
    countries: null,
    positions: null,
    stores: null,
    clusters: null,
    clustersFlat: null,
    loading: false
};

export default (state = initialState, action) => {
	const {type, payload} = action;

    switch (type) {

        case 'FORM_DATA_RESET':
            return initialState;

        //COUNTRIES
        case 'FORM_DATA_LOADING_COUNTRIES':
            return {
                ...state,
                loading: true
            };
        case 'FORM_DATA_GET_COUNTRIES_SUCCESS':
            return {
                ...state,
                loading: false,
                countries: payload
            };
        case 'FORM_DATA_GET_COUNTRIES_FAILURE':
            return {
                ...state,
                loading: false
            };

        ///STORES
        case 'FORM_DATA_LOADING_STORES':
            return {
                ...state,
                loading: true
            };
        case 'FORM_DATA_GET_STORES_SUCCESS':
            let stores = [];

            for (let x in payload) {

                let name = "";
                let id = "";
                if (payload[x].name) {
                    name = payload[x].name;
                }
                if (payload[x].storeName) {
                    name = payload[x].storeName;
                }
                if (payload[x].store) {
                    name = payload[x].store;
                }
                if (payload[x].address) {
                    name = payload[x].address;
                }
                if (payload[x].storeOuId) {
                    payload[x].id = payload[x].storeOuId;
                }
                if (payload[x].id) {
                    id = payload[x].id;
                } else {
                    id = name;
                }

                stores.push({
                    ...payload[x],
                    name: name,
                    id: id,

                })
            }

            return {
                ...state,
                loading: false,
                stores: stores
            };
        case 'FORM_DATA_GET_STORES_FAILURE':
            return {
                ...state,
                loading: false
            };


        ///CLUSTERS
        case 'FORM_DATA_LOADING_CLUSTERS':
            return {
                ...state,
                loading: true
            };
        case 'FORM_DATA_GET_CLUSTERS_SUCCESS':
            let reformatPayload = idToOuId(payload);
            return {
                ...state,
                loading: false,
                clusters: reformatPayload,
                clustersFlat: flatClusters(reformatPayload, null)
            };
        case 'FORM_DATA_GET_CLUSTERS_FAILURE':
            return {
                ...state,
                loading: false
            };


        ///POSITIONS
        case 'FORM_DATA_LOADING_POSITIONS':
            return {
                ...state,
                loading: true
            };
        case 'FORM_DATA_GET_POSITIONS_SUCCESS':
            reformatPayload = idToOuId(payload);

            return {
                ...state,
                loading: false,
                positions: payload,
                positionsFlat: flatPositions(reformatPayload, null)
            };
        case 'FORM_DATA_GET_POSITIONS_FAILURE':
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/formData.js